<template>
  <div class="row justify-content-center user-add-page">
    <div class="col-12">
      <div class="card card-custom">
        <div class="card-body p-0">
          <!--begin: Wizard-->
          <div
            class="wizard wizard-1"
            id="kt_wizard_v1"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <!--begin: Wizard Body-->
            <div
              class="row justify-content-center my-6 px-5 my-lg-8 px-lg-8"
            >
              <div class="col-xl-12">
                <!--begin: Wizard Form-->
                <Form
                  @successPost="$router.push('/masters/users')"
                  routeBack="/masters/users"
                  :form="form"
                  routePost="users"
                  purpose="add"
                  title="Tambah User"
                />
                <!--end: Wizard Form-->
              </div>
            </div>
            <!--end: Wizard Body-->
          </div>
        </div>
        <!--end: Wizard-->
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Form from "@/view/components/users/Form.vue";

export default {
  components: {
    Form,
  },
  data() {
    return {
      form: {
        address: "",
        email: "",
        name: "",
        phone: "",
        photo: null,
        description: "",
        role_id: "",
        password: "",
      },
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "User", route: "/masters/users" },
      { title: "Tambah User" },
    ]);
  },
};
</script>

<style scoped>
.image-input-wrapper {
  width: 250px !important;
  height: 250px !important;
}

.image-input-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
